import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_BOOK_COVER } from "@/settings/constant";
import NextImage from "next/image";
import { useCallback, useState } from "react";
const Image = (param)=>{
    let { src , defaultImage , ...props } = param;
    const [isError, setIsError] = useState(false);
    const initialImage = defaultImage || DEFAULT_BOOK_COVER;
    const onError = useCallback(()=>{
        setIsError(true);
    }, []);
    return /*#__PURE__*/ _jsx(NextImage, {
        ...props,
        src: isError ? initialImage : src || initialImage,
        onError: onError,
        quality: props.quality || 90
    });
};
export default Image;
